import axios from '../http_v2'

// 获取任务列表
let getTaskList = (params) => {
   return axios.get('opservice/taskjob/page', params)
}
// 开始任务
let startTask = (data) => {
  return axios.post('opservice/taskjob/start', data)
}
// 停止任务
let stopTask = (data) => {
  return axios.post('opservice/taskjob/stop', data)
}
// 删除任务
let deleteTask = (data) => {
  return axios.post('opservice/taskjob/delete', data)
}
// 获取短信统计信息
let smsReport = (params) => {
  return axios.get('opservice/taskjob/msgQueueCount', params)
}
// 获取短信统计列表
let smsReportList = (params) => {
  return axios.get('opservice/taskjob/msgQueue', params)
}
// 保存或修改自动化任务
let saveTaskJob = (data) => {
  return axios.post('opservice/taskjob/save', data)
}
// 获取任务的详情
let getTaskDetailInfo = (params) => {
  return axios.get('opservice/taskjob/info', params)
}
 // 获取用户分组信息
let getGroup = (data) => {
  return axios.post('opservice/group/page', data)
}
// 获取标签信息
let getLabel = (data) => {
  return axios.post('opservice/tag/page', data)
}
// 获取国内城市列表
let cityList = () => {
  return axios.get('opservice/opbasedocarea/allcity.json')
}
// 获取国外城市列表
let outCityList = () => {
  return axios.get('opservice/opbasedocarea/allcityAbroad.json')
}
// 获取调查问卷
let getQuestionNaireList = (data) => {
  return axios.post('formbuilder/form/page', data)
}
// 获取调查问卷详情
let getQuestionDetail = (data) => {
  return axios.post('formbuilder/form/get', data)
}
// 获取文章列表
let getArticleList = (params) => {
  return axios.get('content-service/cnt_article/page', params)
}
 // 获取文章详情
let getArticleDetail = (params) => {
  return axios.get('content-service/cnt_article/' + params.id)
}
// 活动分类
let getActiveType = (data) => {
  return axios.post('activityservice/activitysort/list', data)
}
// 活动类型
let getActiveLeiXing = (data) => {
  return axios.post('opservice/opbasedocactivitytype/list', data)
}
// 获取领域信息
let getFieldList = () => {
  return axios.get('content-service/sys_field/list')
}
// 获取行业信息
let getIndustryList = () => {
  return axios.get('content-service/sys_industry/list')
}
// 查询活动信息
let getActiveList = (params) => {
  return axios.post('activityservice/activitysearch/page', params)
}
// 获取活动详情
let getActiveDetail =(params) => {
  return axios.get('activityservice/activitysearch/findone', params)
}

export default {
  getTaskList,
  startTask,
  stopTask,
  deleteTask,
  smsReport,
  smsReportList,
  saveTaskJob,
  getTaskDetailInfo,
  getGroup,
  getLabel,
  cityList,
  outCityList,
  getQuestionNaireList,
  getQuestionDetail,
  getArticleList,
  getArticleDetail,
  getActiveType,
  getActiveLeiXing,
  getFieldList,
  getIndustryList,
  getActiveList,
  getActiveDetail
}